export default __webpack_public_path__ + "static/media/mar2026Dom-th.6e4f3cf5.jpg";